__turbopack_context__.v({
  "tableContainer": "IndicatorTable-module__0A7TMa__tableContainer",
});
